var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "raft-add-new-bio-mat"
    }
  }, [_c('b-link', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.addMaterialStub
    }
  }, [_vm._v("\n    Create a new " + _vm._s(_vm.materialTypeLabel) + "\n  ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }